import {get, post} from '../../../utils/api';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  getRestaurants: () => get({ url: 'restaurant/list' }),
  getRestaurantAddress: params => get({ url: 'restaurant/find', data: { ...params } }),
  getRestaurantStopList: restaurant_id =>
    get({ url: 'cart/stop-list', data: withUnauthorizedToken({ restaurant_id }) }),
  getRestaurantsForSale: () => get({ url: 'restaurant/for-sale-list' }),
  sendFormForSale:  data => post({ url: 'restaurant/for-sale-save', data }),
};
